import {Navigate, Outlet } from 'react-router-dom';
import {AuthContext} from "./AuthContext"; 
import {useContext} from "react";

const ProtectedRoute = ({RenderComponent}) => {
	 const emailaddress = localStorage.getItem("emailaddress"); 
	 return emailaddress ? <Outlet />: <Navigate to="/login" />; 
}
export default ProtectedRoute;

